import React from "react";
import FilterWrapper from "./wrapper";

const FiltersList = ({ children, type = "column" }) => {
  const className = () => {
    switch (type) {
      case "row":
        return "flex flex-col space-x-4";
      case "column":
        return "flex flex-col space-y-4 p-4 w-full";
      default:
        return "flex flex-col space-y-4 p-4 w-full";
    }
  };

  return <div className={className()}>{children}</div>;
};
export default FiltersList;